export const CHAT_ROLES = {
  ME: 'me',
  TINA: 'Tina (AI Oncology Expert)',
};

export const NBA_CHAT_ROOM = 'nba';
export const NEW_USER_CHAT_ROOM = 'new_user';
export const FILE_UPLOAD_CHAT_ROOM = 'file_upload';
export const FILE_UPLOAD_EXPLAIN_CHAT_ROOM = 'file_upload_explain';

export const MESSAGE_TYPES = {
  REACT_NODE: 'react_node',
  PLAIN_TEXT: 'plain-text',
  MARKDOWN: 'markdown',
  ERROR: 'error',
  TRIAL_CARD: 'trial-card',
  TREATMENT_CARD: 'treatment-card',
  SOC_OVERVIEW: 'soc-overview',
  TRIAL_OVERVIEW: 'trial-overview',
  CLINICAL_TRIAL_ANALYTICAL_ANSWER: 'clinical-trial-analytical-answer',
};

export const MESSAGE_TYPE_VALUES = Object.values(MESSAGE_TYPES);
